import { Component, OnInit, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { SearchService } from '../../_services/search.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { Document } from 'src/app/_models/document';
import { environment } from '@environments/environment';
import { User } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { DocumentService } from 'src/app/_services/document.services';
import { AppConfig } from 'src/assets/config/config/app-config';
import { GenAIService } from 'src/app/_services/genAI.service';
import { CategoryService } from 'src/app/_services/category.service';
import { AlertService } from 'src/app/_services/alert.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ISearchForm } from 'src/app/_models/search';

@Component({
  selector: 'app-full-text-search',
  templateUrl: './full-text.component.html',
  styleUrls: ['./full-text.component.scss']
})

export class FullTextSearchComponent implements OnInit {

  @Output() isHome = new EventEmitter<boolean>()
  searchText: string = "";
  submittedSearchText: string = "";
  text: string = "";
  searchResultCount: number = 0;
  searchResults: Array<JSON> = [];
  searchResultsList: MatTableDataSource<any>;
  searchExecuted: boolean = false;
  searchResultsCols: String[] = [];
  selectedRow: Array<JSON>;
  selectedDoc: any;
  rowSelection: boolean = false;
  hideDocList: Boolean = false;
  isEmpty: boolean = false;
  isResult: boolean = false;
  message: string = ""
  backSlash: boolean = false;
  loadDoc: boolean = false;
  openUpload: boolean = false;
  isDocLocked: boolean = false;
  activeDocumentDetails: Document = null;
  documentDetails: Document = null;
  documentID: string;
  hideDocView: Boolean = false;
  isLockUser: boolean = false;
  documentVersions: any;
  documentProp: String[];
  propertyCols: String[];
  openMetaData: boolean = false;
  currentUser: User
  url: any
  enableImageTrust: boolean = false;
  queryEngine:String = "search";
  queryHistory: any[] = [];
  intelligentSearchResults: any[] = null
  notificationMessage:string = null;
  accessibleCategories = [{id:0, label:"All Categories"}]
  enableGenAI:boolean = this.config.getACLGroup().genAI;
  llmModels = this.config.getConfig("genai-llm-models")
  searchCategories:number[] = [0]
  allCategories:number[] = [] 
  allcategories: any;
  searchCtrl:string
  showLoading:boolean = false
  selectedModel:string = "anthropic"
  genAIGenerationMessage:string = ""
  selectedFormDisplayList = []
  systemAttrDisplayList = []
  visibleFields = ["Document Type", "Key Date", "Subject", "Water Right ID"];
  isExportLink: boolean = false;
  selectedForm: ISearchForm;
  searchCriteria: any;
  showArchived: boolean = false;
  isCaseInsensitive: boolean = true;
  selection: SelectionModel<any> = new SelectionModel<any>(true, []);
  isExportMetaDataCsv: boolean = false;
  exportExpiration: number = 60;
  filterValue: string;

  pageSize = 50;
  pageIndex = 0;
  currentPageSize = 0;
  currentStartPageIndex = 0;
  totalDoc: number = 0;
  offset:number = 0;

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.searchResultsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.searchResultsList.paginator = this.paginator;
    }
  }

  constructor(
    private apiSvc: SearchService,
    private documentService: DocumentService,
    private cdref: ChangeDetectorRef,
    private authenticationService: AuthenticationService,
    private config: AppConfig,
    private genAIService: GenAIService,
    private categoryService: CategoryService,
    private alertService: AlertService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit(): void {
    this.notificationMessage = this.config.getConfig("genAINotificationMessage")
    // this.enableGenAI = this.config.getConfig("genAI")
    console.log(this.enableGenAI)
    this.searchText = history.state['text']
    if (this.searchText == undefined) {
      this.searchText = null
    }
    if(this.enableGenAI){
      this.categoryService.getAll().subscribe(resp=>{
        this.allcategories = resp;
        if(resp['results']){
          resp['results'].forEach(category=>{
            this.accessibleCategories.push({id:category.id, label: category.name})
            this.allCategories.push(category.id)
          })
          if(this.searchText){
              this.executeQueryHandler()
          }
        }
      })
    } else {
      this.categoryService.getAll().subscribe(resp=>{
        this.allcategories = resp;
        this.getDisplayListData();        
      })
      if(this.searchText)
        this.executeSearch()
    }
    
  }

  getDisplayListData() {
    var ignoreListForMetadata = ["Document ID", "Document Title", "Document Version", "Created By", "Creation Date", "File Type", "Modified By", "Modified Date", "Size", "Source"];
    this.selectedFormDisplayList = [
      { name: "Document ID", value: "documentId", visible: false, type: "original", data_type: "str"},
      { name: "Document Title", value: "documentName", visible: false, type: "original", data_type: "str"},
      { name: "Document Version", value: "VersionNumber", visible: false, type: "original", data_type: "str"},      
      { name: "Creation Date", value: "createdDate", visible: false, type: "original", data_type: "str"},
      { name: "Created By", value: "created_by", visible: false, type: "original", data_type: "str"},
      { name: "Modified Date", value: "modifiedDate", visible: false, type: "original", data_type: "str"},
      { name: "Modified By", value: "modified_by", visible: false, type: "original", data_type: "str"},
      { name: "Document Source", value: "Source", visible: false, type: "properties", data_type: "str"}
    ]
    for (let category of this.allcategories.results) {
      for (let metaData of category.meta_data_definition) {
        if (metaData.active) {
          for (let property of metaData.properties) {
            var obj = {}
            if (property.name && !ignoreListForMetadata.includes(property.name.trim())) {
              obj["name"] = property.name.trim()
              obj["value"] = property.name.trim()
              obj["data_type"] = property.data_type
              obj["type"] = "properties"
              if (this.visibleFields.includes(property.name)) {
                obj["visible"] = true;
              } else {
                obj["visible"] = false;
              }
              this.selectedFormDisplayList.push(obj)
            } else {
              console.log(property.name)
            }
          }
        }
      }
    }
    this.systemAttrDisplayList = [
      { name: "File Type", value: "type", visible: false, type: "system" },
      { name: "Size", value: "size" , visible: false, type: "system"}      
    ]
    for (let property of this.systemAttrDisplayList) {
      var obj = {}
      obj["name"] = property.name
      obj["value"] = property.value
      obj["type"] = property.type
      obj["data_type"] = "str"
      obj["visible"] = property.visible
      this.selectedFormDisplayList.push(obj)
    }
    this.selectedFormDisplayList = this.removeDuplicateFromDisplayList(this.selectedFormDisplayList, "name");
    this.selectedFormDisplayList = this.sortDisplayList(this.selectedFormDisplayList, "name");
    var additionalColsStr= localStorage.getItem('additionalColumns');    
    if (additionalColsStr) {
      var additionalColsList = JSON.parse(additionalColsStr);
      if (additionalColsList && additionalColsList.length > 0) {
        additionalColsList.forEach(colName => {
          let selectedItem = this.selectedFormDisplayList.filter(selectedForm => selectedForm["name"] === colName);
          if (selectedItem.length > 0) {
            selectedItem[0]["visible"] = true;
          }
        });
      }
    }
  }

  applyShowHideColumns() {
    var additionalCols: String[] = []
    this.searchResultsCols = [];
    this.searchResultsCols.push("select");
    var additionalColumnsStorageList = [];
    this.selectedFormDisplayList.forEach(function (key) {
      if (key.visible) {
        additionalCols.push(key.name);
      }
    });

    additionalCols.forEach((colName:string) => {
      if (!this.visibleFields.includes(colName)) {
        additionalColumnsStorageList.push(colName);
      }
    });

    localStorage.setItem('additionalColumns', JSON.stringify(additionalColumnsStorageList));

    for (var i = 0; i < additionalCols.length; i++) {
      this.searchResultsCols.push(additionalCols[i])
    }
    this.searchResultsCols.push("actionButton");
  }

  removeDuplicateFromDisplayList = (array, key) => {
    var check = new Set();
    return array.filter(obj => !check.has(obj[key]) && check.add(obj[key]));
  }

  sortDisplayList = (array, key) => {    
    return array.sort((a, b) => {
      return a[key].localeCompare(b[key]);
    });
  }


  selectPage(pageOptions) {
    this.pageIndex = pageOptions.pageIndex;
    this.pageSize = pageOptions.pageSize;
    let currentPageSize = this.pageSize;    
    this.currentStartPageIndex = (this.pageIndex * this.pageSize) + 1;
    currentPageSize = currentPageSize * (this.pageIndex + 1);
    if (currentPageSize >= this.searchResultCount && currentPageSize < this.totalDoc) {
      this.offset += 200;
      this.searchPagination();
    }
    this.currentPageSize = currentPageSize;
  }

  searchPagination() {
    this.isEmpty = false
    this.backSlash = false
    var searchReq = {
      "searchstring": String(this.text),
      "limit": 200,
      "offset": this.offset
    };
    this.apiSvc.executeFullText(searchReq)
      .subscribe(resp => {
        resp.body['body'].forEach(element => {
          if (element.active) {
            this.searchResults.push(element)
          }
        });
        this.totalDoc = resp.body['count'];
        this.searchResultCount += resp.body['body'].length

        if (this.searchResultCount > 0) {
          this.searchResultsList = new MatTableDataSource(this.searchResults);
          this.selection = new SelectionModel<any>(true, []);
          this.searchResultsList.sort = this.sort;
          this.searchResultsList.paginator = this.paginator;
          this.searchResultsList.sortingDataAccessor = (item, property) => {
            var list = this.selectedFormDisplayList.filter((obj) => obj.name == property);
            if (list.length > 0) {
              var selectedItem = list[0];
              let value;
              switch(selectedItem["type"]) {
                case 'original': return item[selectedItem["value"]];
                case 'properties': value = item.metadata.properties[selectedItem["value"]];
                                if (selectedItem["data_type"] === 'date'&& value != undefined) {
                                  return new Date(value);
                                }
                                else {
                                  return value;
                                }
                case 'system': return item.metadata.system[selectedItem["value"]];
                default: return item[property];
              }
            } else {
              return null;
            }              
          };
        }
        this.searchExecuted = true
        this.hideDocList = false;
      })
  }

  executeSearch() {
    this.searchExecuted = false
    this.submittedSearchText = this.searchText;
    this.selection.clear();
    this.selectedDoc = null
    this.offset = 0;
    this.searchResults = []
    if (this.searchText === "") {
      this.message = "Please enter a search keyword."
      this.isEmpty = true
      this.backSlash = false
    }
    else {
      this.isEmpty = false
      this.backSlash = false
      this.text = this.searchText
      this.text = escape(this.searchText)
      var searchReq = {
        "searchstring": String(this.text),
        "limit": 200,
        "offset": this.offset
      };
      this.searchResultsCols = [];
      this.searchResultsCols.push("select");
      this.apiSvc.executeFullText(searchReq)
        .subscribe(resp => {
          resp.body['body'].forEach(element => {
            if (element.active) {
              this.searchResults.push(element)
            }
          });
          this.totalDoc = resp.body['count'];
          this.searchResultCount = this.searchResults.length

          if (this.searchResultCount > 0) {
            this.searchResultsList = new MatTableDataSource(this.searchResults);
            this.selection = new SelectionModel<any>(true, []);
             //Get dynamic document columns            
             var additionalCols: String[] = []
             this.selectedFormDisplayList.forEach(function (key) {
               if (key.visible) {
                 additionalCols.push(key.name);
               }
             })
 
             for (var i = 0; i < additionalCols.length; i++) {
               this.searchResultsCols.push(additionalCols[i])
             }
            this.searchResultsCols.push("actionButton");
            this.searchResultsList.sort = this.sort;
            this.searchResultsList.paginator = this.paginator;
            this.searchResultsList.sortingDataAccessor = (item, property) => {
              var list = this.selectedFormDisplayList.filter((obj) => obj.name == property);
              if (list.length > 0) {
                var selectedItem = list[0];
                let value;
                switch(selectedItem["type"]) {
                  case 'original': return item[selectedItem["value"]];
                  case 'properties': value = item.metadata.properties[selectedItem["value"]];
                                if (selectedItem["data_type"] === 'date'&& value != undefined) {
                                  return new Date(value);
                                }
                                else {
                                  return value;
                                }
                  case 'system': return item.metadata.system[selectedItem["value"]];
                  default: return item[property];
                }
              } else {
                return null;
              }              
            };
          }
          this.searchExecuted = true
          this.hideDocList = false;
        })
    }
  }

  executeQueryHandler(){
    try{
      this.showLoading = true
      let categories = this.searchCategories
      if(this.searchCategories.includes(0)){
        categories = this.allCategories
      }
      switch(this.queryEngine){
        case "search":
          this.genAIGenerationMessage ="Fetching relevant content"
          this.queryHistory = []
          this.genAIService.similarityQueryExecutionHandler(this.searchText,categories).subscribe(response1=>{
            // this.intelligentSearchResults = [...response1]
            this.intelligentSearchResults=[]
            this.showLoading = false
            response1.forEach(element=>{
              let versionNumber = (element.file_name.substr(0, element.file_name.lastIndexOf('.'))).substr(element.file_name.lastIndexOf('v')+1,element.file_name.lastIndexOf('v')+2)
              let obj = { 
                        documentName: element.file_name, 
                        text: element.text, 
                        documentId: element.doc_id,
                        confidence: element.score,
                        VersionNumber: parseInt(versionNumber),
                        categoryName: element.category
                      }
              this.intelligentSearchResults.push(obj)
            })
          },
          error=>{
            console.error(error)
            this.showLoading = false
            this.alertService.error("Please try a different key to search. If the issue persists, please contact the DocuEdge administrators")
          })
          //this.queryHistory.push({query: this.searchText, response: response3['generation']['content'], confidence: null})
          break;
        case "chat":
          this.genAIGenerationMessage ="Fetching relevant content and generating your answer"
            this.genAIService.chatQueryExecutionHandler(this.searchText, categories, this.selectedModel).subscribe(response3=>{
            let context = []
            response3.context.forEach(sourceDetails=>{
              let versionNumber = (sourceDetails.file_name.substr(0, sourceDetails.file_name.lastIndexOf('.'))).substr(sourceDetails.file_name.lastIndexOf('v')+1,sourceDetails.file_name.lastIndexOf('v')+2)
              let obj = {documentId : sourceDetails.doc_id,
                VersionNumber: versionNumber,
                documentName: sourceDetails.file_name
              }
              context.push(obj)
            })
            this.queryHistory.push({query: this.searchText, response: response3['generation']['content'], confidence: null, context: context})
            this.showLoading = false
          },
          error=>{
            console.error(error)
            this.showLoading = false
            this.alertService.error("Please try a different prompt. If the issue persists, please contact the DocuEdge administrators")
          })
          break;
      }
    } catch(error){
      this.showLoading = false
      console.error(error)
    }
  }

  clearSearchResults(){
    this.queryHistory = []
    this.intelligentSearchResults= null
    this.searchText = "";
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchResultsList.filter = filterValue.trim().toLowerCase();

    if (this.searchResultsList.paginator) {
      this.searchResultsList.paginator.firstPage();
      this.searchResultCount = this.searchResultsList.filteredData.length
    }
  }

  fetchServiceData() {
    this.hideDocView = true
    this.documentService.getDocumentDetails(this.documentID)
      .subscribe(details => {
        this.hideDocView = false;
        this.activeDocumentDetails = details;
        this.isDocLocked = this.activeDocumentDetails.locked;
        if (details.locked == true && details.locked_by != this.currentUser.username) {
          this.isLockUser = true
        }
      });
  }

  subscribe(docDetails) {
    this.selectedDoc = docDetails
    this.documentID = this.selectedDoc.documentId
    this.fetchServiceData()
  }

  getDocDetails(event, docDetails) {
    this.rowSelection = true;
    this.hideDocList = true;
    this.closeTabs(true)
    this.selectedDoc = docDetails
  }

  loadNew(docId) {
    if (docId) {
      this.loadDoc = true;
      this.getDocDetails(event, docId)
    } else {
      this.loadDoc = false;
    }
  }

  ngAfterContentChecked() {
    //this.selectedRow = undefined
    this.cdref.detectChanges();
  }

  onHideDocList(hide: boolean) {
    if (hide) {
      this.hideDocList = true;
    } else {
      this.hideDocList = false;
      this.selectedRow = undefined;
    }
  }

  openUploadDocument() {
    this.openUpload = true
    this.openMetaData = false
  }

  backFromUpload(hide: boolean) {
    if (hide) {
      this.openUpload = true;
    }
    else {
      this.openUpload = false
      this.selectedDoc.VersionNumber = this.activeDocumentDetails.activeVersion + 1
      this.fetchServiceData()
    }
  }

  annotateDocument() {
    var apiUrl = this.config.getConfig("apiUrl")
    if (apiUrl === "https://km0gvq0iu0.execute-api.us-east-2.amazonaws.com/dev") {
      this.url = `http://in-ith-web.s3-website.us-east-2.amazonaws.com/docuedge-imagetrust-operations.html?&docId=${this.documentID}&dms_user=${this.currentUser.username}&token=${this.currentUser.token}&environment=DocuEdge-Dev`
      window.open(this.url, "_blank");
    }
    else if (apiUrl === "https://il4p364yh4.execute-api.us-east-2.amazonaws.com/dev") {
      this.url = `http://in-ith-web.s3-website.us-east-2.amazonaws.com/docuedge-imagetrust-operations.html?&docId=${this.documentID}&dms_user=${this.currentUser.username}&token=${this.currentUser.token}&environment=DocuEdge-Demo`
      window.open(this.url, "_blank");
    } else {
      alert("Unable to merge, Please contact the system administrator")
    }

  }

  openUpdateMetaData() {
    this.openMetaData = true
    this.openUpload = false
  }

  backFromMetaData(hide: boolean) {
    if (hide) {
      this.openMetaData = true;
    }
    else {
      this.openMetaData = false
      this.executeSearch()
      //this.selectedDoc.VersionNumber = this.activeDocumentDetails.activeVersion + 1
    }
  }

  closeTabs(hide: boolean) {
    if (hide) {
      this.openMetaData = false
      this.openUpload = false
    }
  }

  lockUnlockDocument(lockStatus) {
    this.isDocLocked = !this.activeDocumentDetails.locked
    if (lockStatus) {
      this.documentService.unlockDocument(this.documentID)
        .subscribe(
          resp => {
            this.fetchServiceData()
            //this.ngOnInit()
          },
          error => {
            var errObj = JSON.parse(error.error)
            if (error.error['status'] = 400) {
              //this.appError = errObj.message
            }
          });

    } else {
      this.documentService.lockDocument(this.documentID)
        .subscribe(
          resp => {
            this.fetchServiceData()
            //this.ngOnInit()
          },
          error => {
            var errObj = JSON.parse(error.error)
            if (error.error['status'] = 400) {
              //this.appError = errObj.message
            }
          });
    }
  }

  onEngineChange(event){
    console.log("Event", event.value)
    this.queryEngine = event.value
  }

  onCategoriesChange(){
    console.log("Selected",this.searchCategories)
    // if(this.searchCategories.indexOf('0')>-1){
    //   if(this.searchCategories.length>0){
    //     this.searchCategories = this.searchCategories.slice(this.searchCategories.indexOf('0'), 1)
    //   }
    // }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.searchResultsList.data.length;
    return numSelected === numRows;
  }

  masterToggle(ref) {
    if (this.isSomeSelected()) {

      this.selection.clear();
      ref.checked = false;

    } else {
      this.isAllSelected() ?
        this.selection.clear() :
        this.selecteAll();
    }
  }

  isSomeSelected() {
    return this.selection.selected.length > 0;
  }

  selecteAll() {
    if (this.filterValue) {
      this.searchResultsList.filter = this.filterValue.trim().toLowerCase();
      //console.log(this.allPurgeList.filteredData)
      this.searchResultsList.filteredData.forEach(row => {
        this.selection.select(row.documentId)
      });
    }
    else {
      this.searchResultsList.data.forEach(row => this.selection.select(row.documentId));
    }
  }

    exportDocumentLink() {

    let selectedList = this.selection.selected.join().split(",");
    let totalList = [];
    var request;
    if (selectedList.length > 100) {
      request = {
        "document_ids": totalList,
        "expiration_time": this.exportExpiration,
        "searchstring": this.text,
        "offset": 0,
        "limit": (this.totalDoc),
        "async": true,
      };
      //populate search request

      if (this.showArchived) {
        request.storage_class = "Glacier";
      }
    } else {
      totalList = selectedList;
      request = {
        "document_ids": totalList,
        "expiration_time": this.exportExpiration,
        "async": true
      }
    }
    this.selection.clear();
    this.documentService.exportDocumentsLink(request).subscribe(
      response => {
        this.isExportLink=false;
        console.log("Response " + response);
      });

  }

  exportDocuments() {

    let selectedList = this.selection.selected.join().split(",");
    let totalList = [];
    var request;
    if (selectedList.length > 100) {
      request = {
        "docid": [],
        "searchstring": this.text,
        "offset": 0,
        "limit": (this.totalDoc),
        "storage_class": "S3",
        "async": true,
      };
      //populate search request

      if (this.showArchived) {
        request.storage_class = "Glacier";
      }
    } else {
      totalList = selectedList;
      request = {
        "docid": totalList,
        "async": true
      }
    }
    this.selection.clear();
    this.documentService.exportDocuments(request).subscribe(
      response => {
        console.log("Response " + response);
      });
  }
}